import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormComponent } from '@app/shared/abstracts/form.component';
import { Credentials } from '../../state';

@Component({
  selector: 'tc-login-form',
  templateUrl: './login-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent extends FormComponent<Credentials> {
  @Input()
  showPasswordField?: boolean;

  @Input()
  attempts?: number;

  unlockedDate?: Date;

  @Input()
  set bannedTime(n: number) {
    if (n) {
      this.unlockedDate = new Date(Date.now() + n * 1000);
    }
  }

  @Output()
  readonly emailAndPasswordSubmitted = new EventEmitter<Credentials>();

  @Output()
  readonly emailSubmitted = new EventEmitter<string>();

  get showAttempts(): boolean {
    return typeof this.attempts === 'number' && this.attempts > 0;
  }

  public form = new UntypedFormGroup({
    email: new UntypedFormControl('', Validators.compose([Validators.required, Validators.email])),
    password: new UntypedFormControl('', Validators.required),
  });

  public submit(): void {
    if (this.form.controls.email.valid) {
      if (this.form.valid && this.showPasswordField) {
        this.emailAndPasswordSubmitted.emit(this.normalizedFormValue);
      } else {
        this.emailSubmitted.emit(this.normalizedFormValue.email);
      }
    }
  }
}
